import Vue from 'vue'

Vue.component('section-hello', require('./hello').default)
Vue.component('section-guide', require('./guide').default)
Vue.component('section-goods', require('./goods').default)
Vue.component('section-good', require('./good').default)
Vue.component('section-runtime', require('./runtime').default)
Vue.component('section-game-header', require('./game-header').default)
Vue.component('section-map', require('./map').default)
Vue.component('section-regions', require('./regions').default)
Vue.component('section-upgrade', require('./upgrade').default)
Vue.component('section-result', require('./result').default)
